import { CSSProperties } from "react";

interface Props {
  style?: CSSProperties;
}

export function AiButtonSVGIcon({ style = {} }: Props) {
  return (
    <svg
      width="11"
      height="17"
      viewBox="0 0 11 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M3.63303 18.7286C3.88137 18.8347 4.17011 18.7461 4.31517 18.517L10.9151 8.03041C11.022 7.86068 11.0284 7.64637 10.9317 7.47129C10.835 7.29566 10.6503 7.18661 10.4499 7.18661H6.04515L7.68333 0.685356C7.7494 0.422716 7.61564 0.151459 7.36697 0.0445765C7.11991 -0.0617556 6.82933 0.02738 6.68483 0.256177L0.0849081 10.7427C-0.021974 10.9125 -0.0284274 11.1268 0.0682615 11.3018C0.16495 11.4775 0.349712 11.5865 0.550056 11.5865H4.95485L3.31667 18.0878C3.2506 18.3505 3.38432 18.6217 3.63303 18.7286Z"
        fill="url(#paint0_linear_0_40)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_0_40"
          x1="5.5"
          y1="0"
          x2="5.5"
          y2="18.7731"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6181" />
          <stop offset="1" stopColor="#5C69E3" />
        </linearGradient>
      </defs>
    </svg>
  );
}
